import { MarketingCenteredText } from "../../../components/MarketingCenteredTextBlock"
import { MarketingFooter } from "../../../components/MarketingFooter"
import { MarketingMenu } from "../../../components/MarketingMenu"
import { MarketingOGTags } from "../../../components/MarketingOGTags"
import { MarketingTextSVGHeader, GenericGridDesktop } from "../../../components/MarketingTextSVGHeader"
import { FadeUpContainer } from "../../../components/ReusableStyledComponents/FadeUp"
import { InlineLink } from "../../../components/ReusableStyledComponents/InlineLink"
import { VerticalSpacing } from "../../../components/VerticalSpacing"
import { theme } from "../../../theme/theme"

type V3PrivacySubContractorsProps = {}

export const V3PrivacySubContractors = ({ }: V3PrivacySubContractorsProps) => {


    return <>
        <MarketingOGTags title="Privacy Subcontractors" />
        <MarketingMenu />
        <FadeUpContainer>
            <VerticalSpacing top={20} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 50 }]}>
                <MarketingTextSVGHeader
                    title={<>List of Subprocessors</>}
                    desktopSVG={<GenericGridDesktop />}
                    mobileSVG={<></>}
                    textMaxWidth={750}
                    containerMaxWidth={1320}
                    textMarginTop={50}
                    description={<>All of the subcontractors below are subprocessors under a data processor agreement with Authory.</>}
                />
            </VerticalSpacing>
            <VerticalSpacing top={30} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: -90 }]}>
                <MarketingCenteredText
                    title={""}
                    punchline={<>Google Analytics</>}
                    description={<>
                        <p>
                            <InlineLink href="http://analytics.google.com" target="_blank">analytics.google.com</InlineLink>
                            <br />
                            Location: United States
                            <br />
                            Purpose: Product analytics
                        </p>
                    </>}
                />
            </VerticalSpacing>
            <VerticalSpacing top={60}>
                <MarketingCenteredText
                    title={""}
                    punchline={<>AWS</>}
                    description={<>
                        <p>
                            <InlineLink href="http://aws.amazon.com" target="_blank">aws.amazon.com</InlineLink>
                            <br />
                            Location: European Union/United States
                            <br />
                            Purpose: File storage and cloud computing
                        </p>
                    </>}
                />
            </VerticalSpacing>
            <VerticalSpacing top={60}>
                <MarketingCenteredText
                    title={""}
                    punchline={<>Mailgun</>}
                    description={<>
                        <p>
                            <InlineLink href="http://mailgun.com" target="_blank">mailgun.com</InlineLink>
                            <br />
                            Location: United States
                            <br />
                            Purpose: Transactional emails, emails to subscribers
                        </p>
                    </>}
                />
            </VerticalSpacing>
            <VerticalSpacing top={60}>
                <MarketingCenteredText
                    title={""}
                    punchline={<>Intercom</>}
                    description={<>
                        <p>
                            <InlineLink href="http://intercom.com" target="_blank">intercom.com</InlineLink>
                            <br />
                            Location: United States
                            <br />
                            Purpose: Customer support and communication
                        </p>
                    </>}
                />
            </VerticalSpacing>
            <VerticalSpacing top={60}>
                <MarketingCenteredText
                    title={""}
                    punchline={<>Stripe</>}
                    description={<>
                        <p>
                            <InlineLink href="http://stripe.com" target="_blank">stripe.com</InlineLink>
                            <br />
                            Location: United States
                            <br />
                            Purpose: Payment processing
                        </p>
                    </>}
                />
            </VerticalSpacing>
            <VerticalSpacing top={60}>
                <MarketingCenteredText
                    title={""}
                    punchline={<>PayPal</>}
                    description={<>
                        <p>
                            <InlineLink href="http://paypal.com" target="_blank">paypal.com</InlineLink>
                            <br />
                            Location: United States
                            <br />
                            Purpose: Payment processing
                        </p>
                    </>}
                />
            </VerticalSpacing>
            <VerticalSpacing top={60}>
                <MarketingCenteredText
                    title={""}
                    punchline={<>Chargebee</>}
                    description={<>
                        <p>
                            <InlineLink href="https://www.chargebee.com/" target="_blank">chargebee.com</InlineLink>
                            <br />
                            Location: United States
                            <br />
                            Purpose: Payment processing
                        </p>
                    </>}
                />
            </VerticalSpacing>
            <VerticalSpacing top={60}>
                <MarketingCenteredText
                    title={""}
                    punchline={<>Clarity</>}
                    description={<>
                        <p>
                            <InlineLink href="https://clarity.microsoft.com" target="_blank">clarity.microsoft.com</InlineLink>
                            <br />
                            Location: United States
                            <br />
                            Purpose: Product analytics
                        </p>
                    </>}
                />
            </VerticalSpacing>
            <VerticalSpacing top={120} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 180 }]}>
                <MarketingFooter />
            </VerticalSpacing>
        </FadeUpContainer>

    </>
}